import {
  compose,
  withProps,
  withHandlers,
  withState,
  lifecycle
} from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import withNormalizeValue from 'components/common/hoc/withNormalizeValue'
import SortByPrice from './SortByPrice'
import {
  SORT_BY_PRICE_NAME,
  SORT_BY_INPUT_NAME,
  SORT_BY_INPUT_LABEL
} from '../../constants'
import {
  getSorByPriceURLSearchValue,
  getSelectedOptions
} from '../../helpers'
import { updateSortByPriceQuery } from '../../actions'
import { getActiveVehicleName } from 'selectors/getActiveVehicle'
import { getLocationPathname } from 'selectors/getPageLocation'

const mapStateToProps = state => ({
  vehicleName: getActiveVehicleName(state),
  pathname: getLocationPathname(state)
})

const withSelectedOptionsProps = withProps(() => {
  const options = [
    {
      value: 'lowToHigh',
      label: 'Price - Low To High',
      selected: true
    },
    {
      value: 'highToLow',
      label: 'Price - High To Low',
      selected: false
    },
    {
      value: 'productAZ',
      label: 'Product Line A-Z',
      selected: false
    },
    {
      value: 'productZA',
      label: 'Product Line Z-A',
      selected: false
    }
  ]
  const sortByPriceURLParamValue = getSorByPriceURLSearchValue()
  let selectedOptions = options

  if (sortByPriceURLParamValue) {
    selectedOptions = getSelectedOptions(options, sortByPriceURLParamValue)
  }

  return {
    selectedOptions
  }
})

const withOptionsState = withState('options', 'setOptions', ({ selectedOptions }) => selectedOptions)

const withSortFormViewModel = withProps(({ options }) => ({
  vm: {
    name: SORT_BY_INPUT_NAME,
    label: SORT_BY_INPUT_LABEL,
    options,
    isSearchable: false
  }
}))

const withSortFormHandlers = withHandlers({
  handleFilterChange: ({ options, setOptions, updateSortByPriceQuery }) => ({ value } = {}) => {
    const selectedOptions = getSelectedOptions(options, value)

    setOptions(selectedOptions)
    updateSortByPriceQuery(value)
  }
})


const withSortByPriceLifecycle = lifecycle({
  componentDidUpdate({ vehicleName: prevVehicleName, pathname: prevPathName }) {
    const {
      vehicleName,
      updateSortByPriceQuery,
      options,
      pathname,
      setOptions
    } = this.props

    if (vehicleName !== prevVehicleName) {
      const sortByPriceURLParamValue = getSorByPriceURLSearchValue()
      if (!sortByPriceURLParamValue) {
        updateSortByPriceQuery()

        const selectedOptions = getSelectedOptions(options, 'lowToHigh')

        setOptions(selectedOptions)
      }
    }

    if (prevPathName !== pathname) {
      const sortByPriceURLParamValue = getSorByPriceURLSearchValue()
      let selectedOptions = options

      if (sortByPriceURLParamValue) {
        selectedOptions = getSelectedOptions(options, sortByPriceURLParamValue)
      }

      setOptions(selectedOptions)
    }
  }
})

export default compose(
  connect(mapStateToProps, { updateSortByPriceQuery }),
  withSelectedOptionsProps,
  withOptionsState,
  withSortFormViewModel,
  withSortFormHandlers,
  withSortByPriceLifecycle,
  reduxForm({ form: SORT_BY_PRICE_NAME }),
  withNormalizeValue
)(SortByPrice)
